"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forEachWithIndex = void 0;
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("fp-ts/Record"), exports);
const forEachWithIndex = (f) => (fa) => {
    for (const key in fa) {
        f(key, fa[key]);
    }
};
exports.forEachWithIndex = forEachWithIndex;
//# sourceMappingURL=record.js.map